import React, { useEffect, useState } from "react";
import { AppDetails, BrandFlags, RoomCategories } from "../../configs";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import LabelOutlinedIcon from "@mui/icons-material/LabelOutlined";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import HotelIcon from "@mui/icons-material/Hotel";

function Navbar() {
  const [isSideNavOpen, setIsSideNavOpen] = useState(false);

  const toggleSideNav = () => setIsSideNavOpen(!isSideNavOpen);

  useEffect(() => {
    if (isSideNavOpen) {
      document.body.classList.add("sidenav-open");
    } else {
      document.body.classList.remove("sidenav-open");
    }

    return () => {
      document.body.classList.remove("sidenav-open");
    };
  }, [isSideNavOpen]);

  return (
    <>
      {/* Navbar */}
      <div className="main-navbar-sticky sticky top-0 z-[80] h-20 flex items-center w-full text-primary-main flex-row justify-between lg:px-10 shadow-xl bg-secondary-main/95 backdrop-blur-sm transition-opacity duration-200">
        {/* Logo */}
        <Link
          className="text-xl lg:text-3xl font-bold flex flex-row items-center"
          to="/"
        >
          <img
            src="/logo_expanded.png"
            alt="search"
            className="mr-5 max-h-20"
          />
          {AppDetails.app.name}
        </Link>

        {/* Hamburger Icon for Mobile */}
        <div>
          <button
            onClick={toggleSideNav}
            className="text-primary-main p-2 focus:outline-none"
            aria-label="Toggle menu"
          >
            <MenuIcon fontSize="large" />
          </button>
        </div>
      </div>

      {/* Side Navigation Panel */}
      <div
        className={`fixed top-0 left-0 right-auto lg:right-0 lg:left-auto w-full lg:w-64 h-full overflow-y-auto bg-primary-main shadow-lg z-50 transform transition-transform duration-300 ease-in-out ${
          isSideNavOpen
            ? "translate-x-0"
            : "-translate-x-full lg:translate-x-full"
        }`}
      >
        <div className="border-b text-secondary-medium">
          <div className="flex items-center justify-between p-4 pb-2">
            <span className="text-2xl lg:text-xl font-bold">
              {AppDetails.app.name}
            </span>
            <button
              onClick={toggleSideNav}
              className="p-2 focus:outline-none"
              aria-label="Close menu"
            >
              <CloseIcon fontSize="large" />
            </button>
          </div>
          {BrandFlags.reservationEnabled && (
            <div className="px-4 pb-4">
              <Link
                to="/reserve"
                onClick={toggleSideNav}
                className="block w-full text-center px-4 py-2 bg-secondary-main text-primary-main rounded hover:bg-secondary-dark text-sm font-semibold"
              >
                Reserve Now
              </Link>
            </div>
          )}
        </div>
        <div className="flex flex-col p-4 text-secondary-main w-full text-base lg:text-lg">
          {/* Room Categories Section */}
          <div className="pb-2 border-b border-secondary-medium">
            <div className="text-xs font-semibold text-secondary-medium mb-2 uppercase tracking-wide">
              Room Categories
            </div>
            {RoomCategories.map((category) => (
              <Link
                key={category.id}
                to={`/?room=${category.id}`}
                onClick={toggleSideNav}
                className="flex hover:text-secondary-medium items-center justify-between py-1.5 pl-2"
              >
                <span className="flex flex-col">
                  <span className="flex flex-row items-center gap-2 text-[15px] leading-tight">
                    <HotelIcon fontSize="small" />
                    {category.name}
                  </span>
                  <span className="text-[11px] text-secondary-medium opacity-75 ml-6 leading-tight mt-0.5">
                    {category.shortDescription}
                  </span>
                </span>
                <ArrowForwardIosIcon fontSize="small" />
              </Link>
            ))}
          </div>

          {/* Other Navigation Items */}
          {[
            {
              label: AppDetails.strings.facilitiesButton,
              path: "/facilities",
              description: "View all amenities",
            },
            {
              label: AppDetails.strings.surroundingsButton,
              path: "/surroundings",
              description: "Nearby attractions",
            },
            {
              label: "Guides",
              path: "/guides",
              description: "Stay and trip guides",
            },
            {
              label: AppDetails.strings.finePrintButton,
              path: "/fine-print",
              description: "Policies & rules",
            },
          ].map((item, index) => (
            <div key={index} className="pb-2 border-b border-secondary-medium">
              <Link
                to={item.path}
                onClick={toggleSideNav}
                className="flex hover:text-secondary-medium items-center justify-between py-1.5"
              >
                <span className="flex flex-col">
                  <span className="flex flex-row items-center gap-2 text-[15px] leading-tight">
                    <LabelOutlinedIcon fontSize="small" />
                    {item.label}
                  </span>
                  <span className="text-[11px] text-secondary-medium opacity-75 ml-6 leading-tight mt-0.5">
                    {item.description}
                  </span>
                </span>
                <ArrowForwardIosIcon fontSize="small" />
              </Link>
            </div>
          ))}
        </div>
      </div>

      {/* Backdrop for Side Navigation */}
      <div
        onClick={toggleSideNav}
        className={`fixed inset-0 bg-black transition-opacity duration-300 ${
          isSideNavOpen ? "opacity-50 z-40" : "opacity-0 pointer-events-none"
        }`}
      ></div>
    </>
  );
}

export default Navbar;
